<div class="company_profile_wrapper">
  <!-- OPTIONAL: loading/error (remove if you are hardcoding only) -->
  <div v-if="is_loading" class="text-muted text-sm py-2">Loading...</div>
  <div v-if="error_message" class="text-danger text-sm py-2">
    {{ error_message }}
  </div>

  <!-- TABS HEADER (pill style) -->
  <div class="mb-4">
    <div class="d-flex gap-2 flex-wrap">

      <button
        type="button"
        class="btn btn-sm rounded-3 text-xs fw-semibold"
        :class="active_tab === 'overview'
          ? 'btn-primary'
          : 'btn-outline-secondary'"
        @click="set_active_tab('overview')"
      >
        Company Overview
      </button>

      <button
        type="button"
        class="btn btn-sm rounded-3 text-xs fw-semibold"
        :class="active_tab === 'verification_agency'
          ? 'btn-primary'
          : 'btn-outline-secondary'"
        @click="set_active_tab('verification_agency')"
      >
        Verification Agency
      </button>

      <button
        type="button"
        class="btn btn-sm rounded-3 text-xs fw-semibold"
        :class="active_tab === 'consultant'
          ? 'btn-primary'
          : 'btn-outline-secondary'"
        @click="set_active_tab('consultant')"
      >
        Consultant
      </button>

      <button
        type="button"
        class="btn btn-sm rounded-3 text-xs fw-semibold"
        :class="active_tab === 'bee_team'
          ? 'btn-primary'
          : 'btn-outline-secondary'"
        @click="set_active_tab('bee_team')"
      >
        BEE Team
      </button>

    </div>
  </div>


  <!-- TAB CONTENT -->
  <div class="tab-content bee_tab_content">
    <!-- =========================
         TAB: COMPANY OVERVIEW
         ========================= -->
    <div v-show="active_tab === 'overview'" class="tab-pane-inner">
      <div class="row g-4">

        <!-- COMPANY INFORMATION -->
        <div class="col-12 col-lg-6 d-flex text-xs">
          <div class="card shadow-sm rounded-4 w-100 border-primary">
            <div class="card-body p-4">

              <!-- Header -->
              <div class="d-flex align-items-center mb-3">
                <div class="bg-success bg-opacity-10 rounded-3 p-3 me-3">
                  <i class="bi bi-file-earmark-text text-success fs-6"></i>
                </div>
                <div>
                  <h5 class="fw-semibold mb-0 text-xs">{{ company.company_name }}</h5>
                  <small class="text-muted">Company Information</small>
                </div>
              </div>

              <hr class="my-4">

              <!-- Info Grid -->
              <div class="row g-4">
                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Registration Number</small>
                  <div class="fw-medium">{{ company.registration_number }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">VAT Number</small>
                  <div class="fw-medium">{{ company.vat_number }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">SDL Number</small>
                  <div class="fw-medium">{{ company.sdl_number }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Registered SETA</small>
                  <div class="fw-medium">{{ company.registered_seta }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Industry</small>
                  <div class="fw-medium">{{ company.industry }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Financial Year End</small>
                  <div class="fw-medium">{{ company.financial_year_end }}</div>
                </div>
              </div>

              <hr class="my-4">

              <!-- Contact -->
              <div class="d-flex align-items-start mb-2 text-muted">
                <i class="bi bi-geo-alt me-2"></i>
                <small>{{ company.company_address }}</small>
              </div>

              <div class="d-flex align-items-start mb-2 text-muted">
                <i class="bi bi-telephone me-2"></i>
                <small>{{ company.company_phone }}</small>
              </div>

              <div class="d-flex align-items-start text-muted">
                <i class="bi bi-globe me-2"></i>
                <small>{{ company.company_website }}</small>
              </div>

            </div>
          </div>
        </div>

        <!-- B-BBEE SUMMARY -->
        <div class="col-12 col-lg-6 d-flex text-xs">
          <div class="card shadow-sm rounded-4 w-100 border-primary">
            <div class="card-body p-4">

              <!-- Header -->
              <div class="d-flex align-items-center mb-3">
                <div class="bg-light rounded-3 p-3 me-3">
                  <i class="bi bi-award fs-6"></i>
                </div>
                <div>
                  <h5 class="fw-semibold mb-0 text-xs">B-BBEE Summary</h5>
                  <small class="text-muted">Current compliance status</small>
                </div>
              </div>

              <hr class="my-4">

              <!-- BEE Level Strip -->
              <div class="d-flex justify-content-between align-items-center bg-success bg-opacity-10 rounded-3 p-4 mb-4">
                <div>
                  <small class="text-muted">Current BEE Level</small>
                  <div class="fs-6 fw-bold text-success">
                    {{ bbbee.bee_level }}
                  </div>
                </div>

                <span class="badge rounded-pill bg-success-subtle text-success fw-semibold px-3 py-2">
                  {{ bbbee.bee_status }}
                </span>
              </div>

              <!-- Summary Grid -->
              <div class="row g-4">
                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Measurement Period</small>
                  <div class="fw-medium">{{ bbbee.measurement_period }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Total Employees</small>
                  <div class="fw-medium">{{ bbbee.total_employees }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Black Ownership</small>
                  <div class="fw-medium">{{ bbbee.black_ownership }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Black Female Ownership</small>
                  <div class="fw-medium">{{ bbbee.black_female_ownership }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Certificate Expiry</small>
                  <div class="fw-medium">{{ bbbee.certificate_expiry }}</div>
                </div>

                <div class="col-md-6">
                  <small class="text-uppercase text-muted fw-semibold">Last Verification</small>
                  <div class="fw-medium">{{ bbbee.last_verification }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>


    <!-- =========================
         TAB: VERIFICATION AGENCY
         ========================= -->
    <div v-show="active_tab === 'verification_agency'"
      class="tab-pane-inner">
      <div class="card shadow-sm rounded-4 text-xs border-primary">
        <div class="card-body p-4">

          <!-- ================= HEADER ================= -->
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="d-flex align-items-start gap-3">
              <div class="bg-success bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-shield-check text-success fs-6"></i>
              </div>

              <div>
                <h5 class="fw-semibold mb-0 text-xs">
                  {{ verification_agency.name }}
                </h5>
                <small class="text-muted">
                  Appointed Verification Agency
                </small>
              </div>
            </div>

            <span class="badge rounded-pill bg-success-subtle text-success fw-semibold px-3 py-2">
              {{ verification_agency.accreditation_body }}
            </span>
          </div>

          <hr class="my-4">

          <!-- ================= AGENCY DETAILS ================= -->
          <div class="row g-4 mb-4">
            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Accreditation Number
              </small>
              <div class="fw-medium">
                {{ verification_agency.accreditation_number }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Contact Person
              </small>
              <div class="fw-medium">
                {{ verification_agency.contact_person }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Current BEE Level
              </small>
              <div class="fw-medium">
                {{ bbbee.bee_level }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Certificate Expiry
              </small>
              <div class="fw-medium">
                {{ verification_agency.certificate_expiry }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Last Verification
              </small>
              <div class="fw-medium">
                {{ verification_agency.last_verification }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">
                Contact Details
              </small>

              <div class="d-flex align-items-center text-muted mb-1">
                <i class="bi bi-envelope me-2"></i>
                <span>{{ verification_agency.email }}</span>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="bi bi-telephone me-2"></i>
                <span>{{ verification_agency.phone }}</span>
              </div>
            </div>
          </div>

          <!-- ================= AGENCY ACTIONS ================= -->
          <div class="d-grid gap-2 d-sm-flex mb-5">
            <button class="btn btn-outline-secondary btn-sm text-xs rounded-3">
              <i class="bi bi-file-earmark-text me-2"></i>
              View Certificate
            </button>

            <button class="btn btn-outline-secondary btn-sm text-xs rounded-3">
              <i class="bi bi-calendar-event me-2"></i>
              Schedule Verification
            </button>
          </div>

          <hr class="my-4">

          <!-- ================= DOCUMENTS ================= -->
          <h5 class="fw-semibold mb-1 text-xs">
            Contract &amp; Engagement Documents
          </h5>
          <p class="text-muted mb-4">
            Latest contract and engagement letter with the verification agency
          </p>

          <!-- Document Row -->
          <div
            v-for="doc in verification_documents"
            :key="doc.id"
            class="row g-3 align-items-start align-items-lg-center py-3 border-top"
          >
            <!-- Left -->
            <div class="col-12 col-lg-5">
              <div class="d-flex align-items-start gap-3">
                <div class="bg-success bg-opacity-10 rounded-3 p-3">
                  <i class="bi bi-file-earmark-text fs-5"></i>
                </div>

                <div>
                  <div class="fw-semibold d-flex flex-wrap align-items-center gap-2">
                    {{ doc.title }}
                    <span class="badge bg-success-subtle text-success fw-semibold">
                      Valid
                    </span>
                  </div>
                  <small class="text-muted text-break">
                    {{ doc.filename }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Upload Date -->
            <div class="col-6 col-md-3 col-lg-2 text-start text-md-center">
              <small class="text-muted d-block">Upload Date</small>
              <span class="fw-medium">
                {{ doc.upload_date }}
              </span>
            </div>

            <!-- Expiry Date -->
            <div class="col-6 col-md-3 col-lg-2 text-start text-md-center">
              <small class="text-muted d-block">Expiry Date</small>
              <span class="fw-medium">
                {{ doc.expiry_date }}
              </span>
            </div>

            <!-- Actions -->
            <div class="col-12 col-md-6 col-lg-3">
              <div class="row g-2">
                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-outline-secondary btn-sm text-xs rounded-3">
                    <i class="bi bi-eye"></i>
                    View
                  </button>
                </div>

                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-outline-secondary btn-sm text-xs rounded-3">
                    <i class="bi bi-download"></i>
                    Download
                  </button>
                </div>

                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-primary btn-sm text-xs rounded-3">
                    <i class="bi bi-upload"></i>
                    Upload New
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div
            v-if="!verification_documents || verification_documents.length === 0"
            class="text-muted py-3"
          >
            No verification documents found.
          </div>

        </div>
      </div>
    </div>


    <!-- =========================
         TAB: CONSULTANT
         ========================= -->
    <div v-show="active_tab === 'consultant'" class="tab-pane-inner">
      <div class="card shadow-sm rounded-4 text-xs border-primary">
        <div class="card-body p-4 text-xs">

          <!-- ================================================= -->
          <!-- HEADER : CONSULTANT FIRM -->
          <!-- ================================================= -->
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="d-flex gap-3 align-items-start">
              <div class="bg-success bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-briefcase text-success fs-6"></i>
              </div>

              <div>
                <h5 class="fw-semibold mb-0 text-xs">
                  {{ consultant.firm }}
                </h5>
                <small class="text-muted">
                  Appointed B-BBEE Consultant
                </small>
              </div>
            </div>

            <span class="badge rounded-pill bg-primary border fw-semibold px-3 py-2">
              Registered B-BBEE Consultant
            </span>
          </div>

          <hr class="my-4">

          <!-- ================================================= -->
          <!-- CONSULTANT FIRM DETAILS -->
          <!-- ================================================= -->
          <div class="row g-4 mb-4">
            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">Registration Number</small>
              <div class="fw-medium">{{ consultant.registration_number }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">Contract Start</small>
              <div class="fw-medium">{{ consultant.contract_start }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-uppercase text-muted fw-semibold">Contract End</small>
              <div class="fw-medium">{{ consultant.contract_end }}</div>
            </div>

            <div class="col-12">
              <small class="text-uppercase text-muted fw-semibold">Address</small>
              <div class="d-flex align-items-start text-muted mt-1">
                <i class="bi bi-geo-alt me-2"></i>
                <span>{{ consultant.address }}</span>
              </div>
            </div>

            <div class="col-12">
              <small class="text-uppercase text-muted fw-semibold">Contact Details</small>

              <div class="d-flex flex-column gap-2 mt-1">
                <div class="d-flex align-items-center text-muted">
                  <i class="bi bi-telephone me-2"></i>
                  <span>{{ consultant.phone }}</span>
                </div>

                <div class="d-flex align-items-center text-muted">
                  <i class="bi bi-envelope me-2"></i>
                  <span>{{ consultant.email }}</span>
                </div>

                <div class="d-flex align-items-center text-muted">
                  <i class="bi bi-globe me-2"></i>
                  <span>{{ consultant.website }}</span>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-4">

          <!-- ================================================= -->
          <!-- ASSIGNED CONSULTANT -->
          <!-- ================================================= -->
          <h5 class="fw-semibold mb-1 text-xs">Assigned Consultant</h5>
          <p class="text-muted mb-4">
            Team member responsible for assisting with B-BBEE compliance
          </p>

          <div class="row align-items-center mb-5">
            <div class="col-md-6 d-flex align-items-center gap-4">
              <div
                class="bg-success text-dark rounded-circle d-flex align-items-center justify-content-center fs-6 user-avatar"
              >
                <i class="bi bi-person"></i>
              </div>

              <div>
                <div class="fw-semibold text-xs">
                  {{ consultant.assigned.name }}
                </div>
                <div class="text-muted">
                  {{ consultant.assigned.title }}
                </div>

                <div class="d-flex gap-2 mt-3">
                  <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
                    <i class="bi bi-envelope me-1"></i>
                    {{ consultant.assigned.email }}
                  </button>

                  <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
                    <i class="bi bi-telephone me-1"></i>
                    {{ consultant.assigned.phone }}
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-6 border-start ps-4 mt-4 mt-md-0">
              <small class="text-uppercase text-muted fw-semibold">
                Areas of Specialization
              </small>

              <div class="d-flex flex-wrap gap-2 mt-2">
                <span
                  v-for="area in consultant.assigned.specializations"
                  :key="area"
                  class="badge rounded-pill bg-warning-subtle text-warning-emphasis fw-semibold px-3 py-2"
                >
                  {{ area }}
                </span>
              </div>
            </div>
          </div>

          <hr class="my-4">

          <!-- ================================================= -->
          <!-- CONSULTANT DOCUMENTS -->
          <!-- ================================================= -->
          <h5 class="fw-semibold mb-1 text-xs">Consultant Documents</h5>
          <p class="text-muted mb-4">
            Mandates, POA, NDAs and other supporting documents
          </p>

          <div
            v-for="doc in consultant_documents"
            :key="doc.id"
            class="row g-3 align-items-start align-items-lg-center py-4 border-top"
          >
            <div class="col-12 col-lg-5">
              <div class="d-flex gap-3">
                <div class="bg-success bg-opacity-10 rounded-3 p-3">
                  <i class="bi bi-file-earmark-text text-success fs-6"></i>
                </div>

                <div>
                  <div class="fw-semibold d-flex flex-wrap align-items-center gap-2">
                    {{ doc.title }}
                    <span class="badge bg-success-subtle text-success fw-semibold">
                      Valid
                    </span>
                  </div>
                  <small class="text-muted text-break">{{ doc.filename }}</small>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3 col-lg-2">
              <small class="text-uppercase text-muted fw-semibold">Upload Date</small>
              <div class="fw-medium">{{ doc.upload_date }}</div>
            </div>

            <div class="col-6 col-md-3 col-lg-2">
              <small class="text-uppercase text-muted fw-semibold">Expiry Date</small>
              <div class="fw-medium">{{ doc.expiry_date }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="row g-2">
                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
                    <i class="bi bi-eye"></i> View
                  </button>
                </div>

                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
                    <i class="bi bi-download"></i> Download
                  </button>
                </div>

                <div class="col-12 col-sm-4 d-grid">
                  <button class="btn btn-primary btn-sm rounded-3 text-xs">
                    <i class="bi bi-upload"></i> Upload New
                  </button>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="bg-light rounded-3 p-3 text-muted">
                {{ doc.description }}
              </div>
            </div>
          </div>

          <div
            v-if="!consultant_documents || consultant_documents.length === 0"
            class="text-muted py-3"
          >
            No consultant documents found.
          </div>

        </div>
      </div>
    </div>


    <!-- =========================
         TAB: BEE TEAM
         ========================= -->
    <div v-show="active_tab === 'bee_team'" class="tab-pane-inner bee_tab_pane">

      <!-- ================= BEE PROGRAMME MANAGER ================= -->
      <div class="card shadow-sm rounded-4 p-4 mb-4 text-xs border-primary">

        <div class="mb-3">
          <h5 class="fw-semibold mb-1 text-xs">BEE Programme Manager</h5>
          <p class="text-muted mb-0">
            Key individual responsible for managing the Company BEE Programmes
          </p>
        </div>

        <hr class="my-4">

        <div class="row g-4 align-items-start">

          <!-- LEFT: PROFILE -->
          <div class="col-12 col-lg-6 d-flex gap-3">

            <div
              class="rounded-circle user-avatar bg-success-subtle text-success
                    d-flex align-items-center justify-content-center
                    fs-6 p-3"
            >
              <i class="bi bi-person"></i>
            </div>

            <div>
              <div class="fw-semibold text-xs">{{ bee_manager.full_name }}</div>
              <div class="text-muted">{{ bee_manager.role }}</div>

              <div class="d-flex flex-wrap gap-2 mt-3">
                <span class="btn btn-outline-secondary btn-sm rounded-3 text-xs disabled">
                  <i class="bi bi-envelope me-1"></i>
                  {{ bee_manager.email }}
                </span>

                <span class="btn btn-outline-secondary btn-sm rounded-3 text-xs disabled">
                  <i class="bi bi-telephone me-1"></i>
                  {{ bee_manager.phone }}
                </span>
              </div>
            </div>

          </div>

          <!-- RIGHT: RESPONSIBILITIES -->
          <div class="col-12 col-lg-6 border-start">

            <h6 class="fw-semibold mb-3 text-xs">Key Responsibilities</h6>

            <ul class="list-unstyled mb-0">
              <li
                v-for="(item, idx) in bee_manager.responsibilities"
                :key="idx"
                class="d-flex align-items-start gap-2 mb-2"
              >
                <i class="bi bi-dot text-success fs-5"></i>
                <span>{{ item }}</span>
              </li>
            </ul>

          </div>

        </div>
      </div>

      <!-- ================= BEE ELEMENT OWNERS ================= -->
     <div class="card text-xs shadow-sm rounded-4 p-4 border-primary">

        <div class="mb-3">
          <h5 class="fw-semibold mb-1 text-xs">BEE Element Owners</h5>
          <p class="text-muted mb-0">
            Key staff responsible for each BEE Element
          </p>
        </div>

        <hr class="my-4">

        <!-- ELEMENT ROW -->
        <div
          v-for="row in bee_element_owners"
          :key="row.id"
          class="row align-items-center py-3 border-bottom g-0"
        >

          <!-- COLUMN 1: ELEMENT -->
          <div class="col-12 col-md-4 d-flex align-items-center gap-3">

            <div
              class="rounded-3 text-dark
                    d-flex align-items-center justify-content-center
                    p-3"
              :class="row.icon_bg || 'bg-success'"
            >
              <i :class="row.icon"></i>
            </div>

            <div class="fw-semibold">
              {{ row.element_name }}
            </div>

          </div>

          <!-- COLUMN 2: OWNER -->
          <div class="col-12 col-md-5 d-flex align-items-center gap-3 mt-3 mt-md-0">

            <div
              class="rounded-circle bg-light
                    d-flex align-items-center justify-content-center
                    p-2"
            >
              <i class="bi bi-person text-muted"></i>
            </div>

            <div>
              <div class="fw-semibold">{{ row.owner_name }}</div>
              <div class="text-muted text-sm">{{ row.owner_role }}</div>
            </div>

          </div>

          <!-- COLUMN 3: ACTIONS -->
          <div class="col-12 col-md-3 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">

            <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
              <i class="bi bi-envelope me-1"></i> Email
            </button>

            <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
              <i class="bi bi-telephone me-1"></i> Call
            </button>

          </div>

        </div>

        <div
          v-if="!bee_element_owners || bee_element_owners.length === 0"
          class="text-muted text-center py-3"
        >
          No element owners found.
        </div>

      </div>
    </div>
  </div>
</div>
